module.exports = __webpack_public_path__ + "static/img/pic_chukuyc.fb1fd22d.png";